export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
    fixed: 'left'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_schedule_showScheduleInfo') || '行程安排',
    field: 'scheduleStartDate',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: 'showScheduleInfo'
    }
  },
  {
    title: that.$l('table_label_trip_type') || '业务类型',
    field: 'v_tripType',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_schedule_showCustInfo') || '工厂/客户/订单',
    field: 'custName',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    slots: {
      default: 'showCustInfo'
    }
  },
  {
    title: that.$l('table_label_tripPurpose') || '预计解决问题',
    field: 'tripPurpose',
    align: 'left',
    minWidth: 278,
    showHeaderOverflow: true
  }
]
